<template>
  <div class="tips">
    <div class="header">
      <div class="header-texts">
        <h1>Полезни IT съвети</h1>
        <h1>и практики</h1>
        <p>Ние от cDots помагаме за окабеляване, настройки, мрежи, техника и поддръжка.</p>
        <p>Тук ще прочетете кратки и ефективни съвети как да настройвате интернет рутери, антени, интернет устройства от ново поколение (Интернет на нещата), включително анализи, изкуствен интелект / машинно обучение, облачни сървъри, инфраструктура, сигурност, разработка на софтуер и др.</p>
        <p>
          <a href="/static/cDots_services.pdf" target="_blank" class="tips-link">
            <strong>Всички наши услуги (PDF)</strong>
          </a>
        </p>
      </div>
      <img class="header-img" src="/static/img/tips/tips.webp" alt="Preview" />
    </div>
    <div class="solutions" id="solutions">
      <div class="solutions-header">
        <h6 @click="isMenuHidden = false">Последни tips & tricks</h6>
      </div>
      <div class="solutions-content">
        <div class="solutions-content-itemless">
          <img src="/static/img/tips/1.webp" alt="tips" />
          <div class="solutions-content-itemless-texts">
            <h5>Включване и изключване на Ф клавишите (F клавишите) на клавиатурата</h5>
            <p>
              Ако имате съвременен лаптоп - най-вероятно при натискане на някои от F клавишите (F1, F2, F3...F12) става друго, но не и функцията която искате?!
              За еднократно превключване може да натиснете и задържите бутона Fn (обикновено долу в ляво на клавиатурата) и еднократно желания F клавиш (примерно Fn+F1, което ще ви отвори help-а на програмата).
              А, ако искате постоянно да превключите тяхната работа, без да натискате постоянно Fn бутона - то използвайте Fn+Esc
            </p>
            <p>
              <strong>
                При нужда от съдействие от всякакъв тип
                <a
                  class="tips-link"
                  href="/contacts"
                >пишете ни тук</a>, или ни се обадете на
                <a class="tips-link" href="tel:+359884218868">0884218868</a>
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div class="solutions-content">
        <div class="solutions-content-itemless">
          <img src="/static/img/tips/2.webp" alt="tips" />
          <div class="solutions-content-itemless-texts">
            <h5>Какво е рутер, какво е суич (router и switch)?</h5>
            <p>Рутерът (router) е устройството, което Ви трябва за да имате интернет. Най-общо казано доставчика на интернет Ви докарва кабел в къщата/апартамента/офиса/… този кабел трябва да се сложи в рутера, на определено място. Това място обикновено е дупка обозначена с надписа WAN, може да е нещо като картинка имитираща няколко компютри или друго.</p>
            <p>Дори и най-евтиния рутер има няколко дупки, за някои от които пише по-долу, но задължителните са две: едната е за захранване :) където се включва в тока, има и малко бутонче и/или дупчица за връщане на фабрични настройки (ресетване на устройството) и дупка WAN за интернета. Рутерите могат да бъдат безжични (wireless) или просто устройство приемащо интернета. Останалите дупки в рутера обикновено са означени с цифри и те имат връзка с долния абзац.</p>
            <p>Суичът (switch) е устройство, което пуска интернет на няколко компютри и/или устройства едновременно. Разбирате нали – кабела за интернета Ви е само един, а компютрите два-три-четири, а може и повече!? Това е устройството, което ще даде интернет на всички тях едновременно по кабел. То много прилича на рутера, защото има захранващ кабел за ток, и захранващ кабел с интернет идващ от рутера, а до него 4-5-6 до 24 дупки в някои случаи за разклонение.</p>
            <p>Имали ли комбинирани устройства – всъщност повечето рутери, които могат да се закупят свободно от магазина имат няколко дупки – дори и най-евтините, такава за WAN и дупки с цифри 1-2-3… които представляват разклонението за други устройства.</p>
            <p>
              <strong>
                При нужда от съдействие от всякакъв тип
                <a
                  class="tips-link"
                  href="/contacts"
                >пишете ни тук</a>, или ни се обадете на
                <a class="tips-link" href="tel:+359884218868">0884218868</a>
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div class="solutions-content">
        <div class="solutions-content-itemless">
          <img src="/static/img/tips/3.webp" alt="tips" />
          <div class="solutions-content-itemless-texts">
            <h5>Какво е безжичен рутер и опасно ли е лъчението</h5>
            <p>Повечето рутери за домашни условия за безжични – даже бихме казали 99.99% от устройствата за домашно ползване са безжични. Всяко устройство имащо възможност да ползва безжичен интернет с лесни (за по запознатите) стъпки, чрез които се свързва устройството (телефона) към безжичния рутер и така си имате интернет без необходимост от кабел.</p>
            <p>Да те разпръскват сигнал, но той е радио сигнал – това НЕ Е ЛЪЧЕНИЕ. С други думи по-безопасни са дори от мобилните телефони! Не, няма опасност за бебета, малки деца, възрастни хора.</p>
            <p>Свързване на печка, пералня, хладилник, кафемашина, бойлер към интернет и управлението им отдалечено (през телефона примерно или от офисния компютър)</p>
            <p>Изброените устройства могат да се управляват, ако са модерни (обикновено и скъпи). Управлението означава от офиса или от телефона си - да намалиш градусите за изстудяване на хладилника или увеличиш градусите на климатика. Да изключиш забравената кафе машина от сутринта или печка</p>
            <p>
              <strong>
                При нужда от съдействие от всякакъв тип
                <a
                  class="tips-link"
                  href="/contacts"
                >пишете ни тук</a>, или ни се обадете на
                <a class="tips-link" href="tel:+359884218868">0884218868</a>
              </strong>
            </p>
          </div>
        </div>
      </div>
    </div>
    <Consultation />
  </div>
</template>

<script>
import Consultation from './Consultation';
export default {
  components: {
    Consultation: Consultation
  },
  data() {
    return {
      solutions: Solutions,
      isMenuHidden: true
    };
  },
  watch: {
    $route(to, from) {
      this.filterSolutions();
      this.isMenuHidden = true;
    }
  },
  methods: {
    filterSolutions() {
      if (this.$route.name === 'HomeCategorySelected') {
        const category = this.$route.params.category;
        this.solutions = Solutions.filter(o => {
          return o.category === category;
        });
      } else {
        this.solutions = Solutions;
      }
    }
  },
  mounted() {
    this.filterSolutions();
  }
};
</script>

<style scoped>
.home {
  overflow: hidden;
}
h6 {
  font-size: 20px;
  letter-spacing: 10px;
  padding-top: 30px;
  color: #959595;
  font-weight: 100;
  text-align: center;
}
h5 {
  font-size: 20px;
  color: #0f63eb;
  font-weight: 100;
  margin: 30px 0;
  text-align: left;
}
p {
  font-size: 16px;
  font-weight: 100;
  /* margin: 30px 0; */
  line-height: 24px;
  /* text-align: center; */
}

.tips-link {
  color: #0f63eb;
}
.tips-link:hover {
  opacity: 0.8;
}

/* HEADER */
.header {
  align-items: center;
  display: flex;
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 40px;
  position: relative;
  width: 100%;
}
.header-texts {
  width: 70%;
}
.header-texts > h1:last-of-type {
  margin-bottom: 30px;
}
.header-texts > p {
  margin-bottom: 15px;
  width: 90%;
}
.header-texts > p:last-child {
  margin-bottom: 0;
}
.header-img {
  max-width: 1000px;
  position: absolute;
  right: 0%;
  top: 50px;
  width: 50%;
}
/* SOLUTIONS */
.solutions {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.solutions-header-content {
  display: flex;
}
.solutions-header-item {
  align-items: center;
  background-color: #f8f8f8;
  border-radius: 4px;
  color: #3f3f3f;
  cursor: pointer;
  display: inline-flex;
  height: 90px;
  justify-content: center;
  margin-right: 20px;
  padding: 20px;
  text-align: center;
  width: 160px;
}
.solutions-header-item:last-of-type {
  margin: 0;
}
.solutions-header-item:hover {
  background-color: #ebebeb;
}
.solutions-header-item-active {
  background-color: #d9d9d9;
}
.inactive {
  cursor: default;
}
.inactive:hover {
  background-color: #f8f8f8;
}
/* SOLUTION ITEMS */
.solutions-content {
  display: flex;
  flex-wrap: wrap;
  padding: 55px 0;
  width: 1300px;
}
.solutions-item {
  width: 400px;
  margin-right: 50px;
  margin-bottom: 40px;
}
.solutions-item:nth-of-type(3n) {
  margin-right: 0;
}
.solutions-item-img {
  border-radius: 15px;
  width: 100%;
}
.solutions-item-description {
  color: #000;
  margin: 15px 0 5px;
}
.solutions-item-name {
  color: #929292;
  font-size: 14px;
}
.solutions-content-itemless {
  align-items: center;
  display: flex;
}
.solutions-content-itemless img {
  margin-right: 3%;
  width: 37%;
}
.solutions-content-itemless-texts {
  margin-left: 3%;
  width: 57%;
}
.solutions-content-itemless-texts p {
  margin-bottom: 15px;
}
.no-solutions {
  opacity: 0.6;
  text-align: center;
  width: 100%;
}
.arrow {
  display: none;
}
/* RESPONSIVE */
@media screen and (max-width: 1600px) {
  .header-texts > h1:last-of-type {
    margin-bottom: 25px;
  }
  .solutions-header-item {
    font-size: 14px;
    width: 150px;
  }
  .solutions-header-content {
    width: 1200px;
  }
  .solutions-content {
    padding: 60px 0;
    width: 1120px;
  }
  .solutions-item {
    width: 340px;
  }
}
@media screen and (max-width: 1440px) {
  .header {
    padding: 30px 100px;
  }
  .header-texts > h1:last-of-type {
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 1366px) {
  .solutions-header > h6 {
    margin: 25px 0;
  }
  .solutions-header-item {
    font-size: 12px;
    height: 75px;
    width: 150px;
  }
  .solutions-header-content {
    width: 1100px;
  }
  .solutions-content {
    padding: 40px 0;
    width: 1000px;
  }
  .solutions-item {
    width: 300px;
  }
  .solutions-item-description {
    font-size: 13px;
    margin: 10px 0 0px;
  }
  .solutions-item-name {
    font-size: 12px;
  }
}
@media screen and (max-width: 1280px) {
  .header-img {
    display: none;
  }
  .header {
    padding: 20px;
  }
  .header-texts {
    width: 100%;
  }
  .header-texts h1 {
    text-align: center;
  }
  .header-texts p {
    text-align: center;
    width: 100%;
  }
  .header-texts > h1:last-of-type {
    margin-bottom: 10px;
  }
  .solutions-header {
    width: 100%;
    padding: 0 20px;
  }
  .solutions-header-content {
    width: 100%;
  }
  .solutions-header-item {
    width: 12.5%;
  }
  .solutions-content {
    padding: 20px;
    width: 100%;
  }
  .solutions-item {
    width: calc(33.33% - 13.33px);
    margin-right: 20px;
  }
}
@media screen and (max-width: 1000px) {
  .solutions {
    padding-bottom: 63px;
  }
  .solutions-header-content {
    flex-wrap: wrap;
  }
  .solutions-header-item {
    height: 50px;
    margin-right: 20px;
    width: calc(25% - 15px);
  }
  .solutions-header-item:nth-child(4n) {
    margin-right: 0;
  }
  .solutions-header-item:nth-child(n + 5) {
    margin-top: 20px;
  }
  .solutions-content {
    padding: 20px 40px;
  }
  .solutions-content-itemless {
    flex-direction: column;
  }
  .solutions-content-itemless img {
    width: 85%;
    margin: 0 0 0px;
  }
  .solutions-content-itemless-texts {
    margin: 15px 0 0;
    width: 100%;
  }
  .solutions-content-itemless-texts p {
    text-align: center;
  }
}
@media screen and (max-width: 800px) {
  .header {
    padding-top: 0;
  }
  .solutions-item {
    margin-bottom: 20px;
    width: calc(50% - 10px);
  }
  .solutions-item:nth-of-type(3n) {
    margin-right: 20px;
  }
  .solutions-item:nth-of-type(2n) {
    margin-right: 0;
  }
}
@media screen and (max-width: 600px) {
  .solutions {
    padding-bottom: 50px;
  }
  .solutions-header > h6 {
    cursor: pointer;
    margin: 0;
    padding: 25px;
  }
  .solutions-header-item {
    margin: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 100%;
  }
  .solutions-header-item:nth-child(n + 5) {
    margin: 0;
  }
  .solutions-header-item-hidden {
    height: 0px;
    padding: 0;
  }
  .solutions-item {
    width: 100%;
    margin: 0 0 20px;
  }
  .solutions-item:nth-of-type(3n) {
    margin-right: 0;
  }
  .solutions-content {
    padding: 20px;
  }
  .solutions-header > h6 {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .arrow {
    display: inline-block;
    height: 16px;
    margin-left: 10px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 16px;
  }
  .arrow-rotated {
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tips.vue